export default __webpack_public_path__ + "static/media/photo5.d1334e9b.jpg";